import _toLower from 'lodash/toLower';

export const getApiMiningType = ({
  miner,
  account,
  coin,
}: {
  miner: string | null;
  account: string | null;
  coin?: string;
}) => {
  const isAnonymous = !!miner;
  const isAccount = !!account && !isAnonymous;
  const miningType = isAnonymous ? 'anonymous' : 'accounts';
  const accOrMiner = miner || account;
  
  // for anonymous mining, we should use coin name in lowercase, e.g btc
  let coinPath = _toLower(coin);
  // for account mining btc, we should use /sha256/
  if (isAccount && coin === 'BTC') { coinPath = 'sha256'; }

  const urlPart = `${miningType}/${accOrMiner}/${coinPath}`;
  const urlPartShort = `${miningType}/${accOrMiner}`;
  
  return {
    miningType,
    accOrMiner,
    coinPath,
    urlPart,
    urlPartShort,
  }
}